<template>
  <b-container class="register-container" align-v="center">
    <b-row align-h="center" class="register-center-container" align-v="center">

      <!-- Card -->
      <b-card class="register-card"
              header-tag="header"
              footer-tag="footer">

        <!-- Header -->
        <div slot="header"
             class="row">
          <icon class="col-12"
                name="user"
                scale="4" />
          <div class="col-12 register-card-title"><h3>Inscription</h3></div>
        </div>
        <!-- Form Login -->
        <b-form @submit="register"
                id="app-register-form">

          <!-- Email or username -->
          <b-form-group id="emailGroup"
                        label="Adresse email"
                        label-for="registerEmail">
            <b-form-input id="registerEmail"
                          type="email"
                          v-model="formRegister.email"
                          required
                          placeholder="Entrez votre adresse email">
            </b-form-input>
            <!-- Alert -->
            <ValidationErrorAlert :form-error-list="getFormRegisterError.email"/>

          </b-form-group>

          <!-- Password -->
          <b-form-group id="passwordGroup"
                        label="Mot de passe"
                        label-for="registerPassword">
            <b-form-input id="registerPassword"
                          type="password"
                          v-model="formRegister.password"
                          required
                          placeholder="Entrez votre mot de passe">
            </b-form-input>

            <!-- Alert -->
            <ValidationErrorAlert :form-error-list="getFormRegisterError.password"/>

          </b-form-group>
        </b-form>

        <!-- Footer -->
        <em slot="footer">

          <!-- Submit login form -->
          <b-button
                  form="app-register-form" class="register-submit"
                  type="submit"
                  variant="primary">
            S'enregistrer
          </b-button>
        </em>
      </b-card>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'RegisterType',
  props: {
    isRowTable: { type: Boolean, default: false },
    isModal: { type: Boolean, default: false },
  },
  data() {
    return {
      formRegister: {
        email: '',
        password: '',
      },
      showSpinner: false,
    };
  },
  computed: {
    ...mapGetters([
      'getFormRegisterError',
    ]),
  },
  methods: {
    register(event) {
      event.preventDefault();
      event.stopPropagation();
      this.$store.commit('setGlobalSpinnerShow', true);
      this.$store.dispatch('register', this.formRegister)
        .then(() => {
          // Show success toast
          const toast = {
            show: true,
            message: 'Utilisateur créé avec succès !',
            variant: 'success',
            duration: 3000,
          };
          this.$store.commit('setGlobalToaster', toast);
          // Update/Get the list of users
          this.$store.dispatch('getUsers').then();
        }, (error) => {
          console.log(error);
          // Update error form in store
          this.$store.commit('setFormRegisterError', error);
        })
        .finally(() => {
          this.$store.commit('setGlobalSpinnerShow', false);
          this.formRegister.email = '';
          this.formRegister.password = '';
        })
      ;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .register-center-container {
    margin: 0;

    .register-card {
      width: 100%;

      .register-card-title {
        text-align: center;
      }

      .register-submit {
        display: block;
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/user/RegisterType.vue